import { Component } from '@angular/core';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { InvoiceService } from 'src/app/services/invoice.service';

@Component({
    selector: 'app-billing-summary',
    templateUrl: './billing-summary.component.html',
    styleUrls: ['./billing-summary.component.scss'],
    standalone: false
})
export class BillingSummaryComponent {
     isDownloading: boolean = false;
     periodList: string[] = [];
     companyType: string = 'MC';
     billingPeriod: string = '';
     loginEmail: string = '';
     reportType: string = 'PDF';
     reportLevel: string = '1';
     showTotals: string = '0';
     orderByLogin: string = '0';
     customerId: string = '';
     userProfile?: UserProfile;
     showReportDownloadedAlert: boolean = false;


     constructor(public generalService: GeneralService,
          private authenticationService: AuthenticationService, public invoiceService: InvoiceService,) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.customerId = this.userProfile!.customerId;
          //this.loginEmail = this.$store.getters['authentication/username'];
          this.periodList = invoiceService.getCdbBillingCyclesList();
          this.billingPeriod = this.periodList[0];
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     pageValid(): boolean {
          if (this.billingPeriod && Number(this.customerId)   && this.showTotals && this.orderByLogin && this.reportLevel ) {
               return true;
          }
          return false;
     }

     downloadReport() {
          if (this.billingPeriod === '') {
               console.error("No billing period selected");
               return;
          }

          this.isDownloading = true;
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.invoiceService.getBillingSummaryReport(Number(this.customerId), this.billingPeriod, this.reportType, this.loginEmail, this.showTotals, this.orderByLogin, this.reportLevel).subscribe((result: any) => {
               const filename = (this.reportType === 'PDF') ? `BillingSummaryReport-${this.billingPeriod}.pdf` : `BillingSummaryReport-${this.billingPeriod}.csv`;
               const element = document.createElement('a');
               element.setAttribute('href', 'data:application/octet-stream;base64,' + result);
               element.setAttribute('download', filename);
               element.style.display = 'none';
               document.body.appendChild(element);
               element.click();
               document.body.removeChild(element);
               this.isDownloading = false;
               this.showReportDownloadedAlert = true;
          });
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
